import React, { useState } from 'react';
import { axiosInstance } from '../config';
import './Login.css';

const Login = ({ setUser, onLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await axiosInstance.post('/api/auth/login', formData);
      console.log('Login response:', response.data);
      
      const { token, user, business } = response.data;

      // Set axios default authorization header
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      // Before setting localStorage
      console.log('Setting environment:', user.environment);
      localStorage.setItem('userEnvironment', user.environment);
      
      // Store complete business object in localStorage
      if (business) {
        localStorage.setItem('businessId', business.id);
        localStorage.setItem('businessName', business.name);
        localStorage.setItem('businessEmail', business.email);
        localStorage.setItem('businessEmailFrequency', business.email_frequency);
        localStorage.setItem('businessAvailableCredits', business.available_credits);
        localStorage.setItem('businessUsedCredits', business.used_credits);
        localStorage.setItem('businessCanRunManualChecks', business.can_run_manual_checks ? 'true' : 'false');
      }
      
      // Update the application state and handle navigation
      await onLogin({ 
        token, 
        user: {
          ...user,
          environment: user.environment || 'test'
        }, 
        business: {
          ...business,
          email_frequency: business.email_frequency,
          available_credits: business.available_credits,
          used_credits: business.used_credits,
          can_run_manual_checks: business.can_run_manual_checks
        }
      });
      
    } catch (error) {
      console.error('Login error:', error);
      setError(error.response?.data?.error || 'Login failed');
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  return (
    <div className="login-container">
      <div className="brand-title">
        <h1>SafetyCheckNow</h1>
        <div className="subtitle">Secure Portal</div>
      </div>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>
        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default Login; 